import React from 'react';
import './Project.css'

const ProjectText = () => (

  <div className='dhtextcontainer'>
    <h1 className='dhtitle'>Recent Personal Project</h1>
    <p className='dhtext'>
      One of the web apps I built was a moblie first Progressive Web App.
      Built using React it uses the YouTube API to fetch the most resent songs in dancehall.
      I was tired of going from one YouTube channal to the next to listen to my dancehall.
      So I solve my problem with a website.
      It's called <a className='dancehallapp' href='https://dancehall-lite.firebaseapp.com/'>dancehall-lite</a>.
    </p>
  </div>
)

export default ProjectText;



// WEBPACK FOOTER //
// ./src/container/Project/ProjectText.js